import "core-js/modules/es.array.join";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
var $elem = $('._js-tel');
var cond = /-/;
var rawTelNum = $elem.text().split(cond).join(''); // 指定以下のサイズ時に a:tel のリンクで電話番号を包含する

if (window.matchMedia("(max-width: 768px)").matches) {
  var $a = $('<a></a>').attr('href', "tel:".concat(rawTelNum));
  $elem.wrapInner($a);
}